import { QueryKeysEnum } from '@/enums';
import {
  CreateCycleDonor,
  CycleParams,
  DonorCycleEntity,
  UpdateCycleDonor,
} from '@/types';
import { BaseService } from './base.service';
import APIService from './axios.service';

class CycleDonorService extends BaseService<
  'cycle',
  DonorCycleEntity,
  CreateCycleDonor
> {
  constructor() {
    super(QueryKeysEnum.FMT_CYCLE);
  }

  getAllCycles = (payload: CycleParams): Promise<DonorCycleEntity[]> => {
    const params: CycleParams = { ...payload, isFetchAll: true };
    return APIService.get(this.path, { params });
  };

  updateCycle = (payload: {
    id: string;
    data: UpdateCycleDonor;
  }): Promise<DonorCycleEntity> => {
    const { id, data } = payload;
    return APIService.patch(this.path + '/' + id, data);
  };
}

export const cycleDonorService = new CycleDonorService();
